import { TreeType } from '../markdown.types';
import { addMissedTags } from './addMissedTags/addMissedTags';
import { generateTree } from './generateTree/generateTree';
import { getMissedTags } from './getMissedTags/getMissedTags';
import { getSymbolsPositions } from './getSymbolsPositions/getSymbolsPositions';
import { mergeTagsInList } from './mergeTagsInList/mergeTagsInList';
import { IParseToTreeOptions } from './parseToTree.types';
import { removeTags } from './removeTags/removeTags';

export const parseToTree = (opts: IParseToTreeOptions): TreeType => {
  const {
    text,
    hasBotCommands = false,
    isPlainText = false,
    userMentions = [],
    keyWords = [],
  } = opts;

  try {
    const sortedUserMentions = userMentions
      .slice()
      .sort((a, b) => b.nickname.length - a.nickname.length);

    const { hasSymbols, symbolsPositions } = getSymbolsPositions({
      userMentions: sortedUserMentions,
      hasBotCommands,
      text,
      keyWords,
    });

    if (!hasSymbols) {
      return [
        {
          tag: 'text',
          content: text,
        },
      ];
    }

    const positionToTag = mergeTagsInList({ symbolsPositions });

    if (isPlainText) {
      const plainText = removeTags({ text, positionToTag });

      return [
        {
          tag: 'text',
          content: plainText,
        },
      ];
    }

    const missedTags = getMissedTags({ positionToTag });

    const { updatedText, updatedPositionToTag } = addMissedTags({
      text,
      positionToTag,
      missedTags,
    });

    const tree = generateTree({
      text: updatedText,
      positionToTag: updatedPositionToTag,
    });

    return tree;
  } catch (e) {
    return [
      {
        tag: 'text',
        content: text,
      },
    ];
  }
};
